import axios, { AxiosInstance } from 'axios'
import { API_BASE_URL } from 'config/appConstants'

const axiosInstance: AxiosInstance = axios.create({ baseURL: API_BASE_URL })
export { axiosInstance as instance }
